<template>
<div>
  <b-navbar type="blue" class="blue" align="end">
     <b-navbar-nav>
        <b-nav-item v-if="isInProfil() || isInAuftrag()" @click="$router.go(-1)"><i class="bi bi-arrow-left"></i></b-nav-item>
      </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="user" to="/AGB" right>AGB</b-nav-item>
        <b-nav-item v-if="user" to="/FAQ" right>FAQ</b-nav-item>
        <b-nav-item v-if="user" to="/logout">Abmelden</b-nav-item>
        </b-navbar-nav>
  </b-navbar>

  <transition name="fade" mode="out-in">
  <component :is="menuComponent()" :user="user"></component>
 </transition>

  <div>
    <b-sidebar id="sidebar-1" bg-variant="transparent" right  no-header body-class="blue side-nav shadow">
      <div class="px-3 py-2">

  <b-nav vertical class="w-25">
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-if="user" to="/AGB" right>AGB</b-nav-item>
        <b-nav-item v-if="user" to="/FAQ" right>FAQ</b-nav-item>
        <b-nav-item v-if="user" to="/logout">Abmelden</b-nav-item>
      </b-navbar-nav>
      </b-nav>
      </div>
 </b-sidebar>
    </div>

</div>
</template>
<script>
import utils from '@/utilities'
import TopMenu from '@/components/partials/TopMenu'
import ProfilMenu from '@/components/partials/ProfilMenu'

export default {
  name: 'MainMenu',
  components: {TopMenu, ProfilMenu},
  props: ['user'],
  data () {
    return {
      componentKey: 0
    }
  },
  methods: {
    isInAuftrag () {
      return (this.$route.name === 'Auftrag')
    },
    isInProfil () {
      return (this.$route.name === 'WrappedProfil' || this.$route.name === 'Benutzer')
    },
    menuComponent () {
      return this.isInProfil() ? 'ProfilMenu' : 'TopMenu'
    },
    hasRoles (role) {
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), role)
    },
    forceRerender () {
      this.componentKey += 1
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/main/vue/components/MainMenu.vue